import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { toJS } from 'mobx';
import { cast, getParent, types } from 'mobx-state-tree';
import moment from 'moment';
import { api } from 'src/api';
import { createAsync } from 'src/utils/asyncModel';
const getFinalStatementsAsync = createAsync(body => {
  return async function getFinalStatements(options) {
    const resp = await api.Payment.getFinalStatements(body, options);
    const _getParent = getParent(this),
      fse = _getParent.fse;
    fse.setFinalStatementsAfterLoad(resp);
    return resp;
  };
});
const getFSEInfosAsync = createAsync(body => {
  return async function getFSEInfos(options) {
    const resp = await api.Payment.getFSEInfos(body, options);
    const _getParent2 = getParent(this),
      fse = _getParent2.fse;
    fse.setFSEInfosAfterLoad(resp);
    return resp;
  };
});
const submitFinalStatementsAsync = createAsync(body => {
  return async function submitFinalStatements(options) {
    const resp = await api.Payment.submitFinalStatements(body, options);
    const _getParent3 = getParent(this),
      fse = _getParent3.fse;
    fse.setFinalStatementsAfterSubmit(resp);
    return resp;
  };
});
const updateFinalStatementsAsync = createAsync(body => {
  return async function updateFinalStatements(options) {
    const resp = await api.Payment.updateFinalStatements(body, options);
    return resp;
  };
});
const FSEBillModalData = types.model('FSEBillModalData', {
  accountId: types.optional(types.string, ''),
  residentName: types.optional(types.string, ''),
  propertyId: types.optional(types.string, ''),
  residencyId: types.string,
  unitName: types.optional(types.string, '')
});
const FSEPosted = types.model('FSEPosted', {
  batchId: types.maybeNull(types.string),
  fileId: types.maybeNull(types.string),
  month: types.number,
  paperStatementId: types.maybeNull(types.string),
  propertyId: types.string,
  residencyId: types.string,
  residentAccountId: types.string,
  residentId: types.string,
  year: types.number
});
const FinalStatement = types.model('FinalStatement', {
  averagePerDay: types.number,
  capAmount: types.maybeNull(types.number),
  chargeAmount: types.maybeNull(types.number),
  chargeMemo: types.maybeNull(types.string),
  creditAmount: types.maybeNull(types.number),
  creditMemo: types.maybeNull(types.string),
  id: types.string,
  isExcluded: types.boolean,
  daysCount: types.number,
  periodEndDateOnly: types.maybeNull(types.string),
  periodStartDateOnly: types.maybeNull(types.string),
  recommendedCharge: types.maybeNull(types.number),
  recommendedCredit: types.maybeNull(types.number),
  total: types.number,
  totalCharges: types.number,
  totalDaysCount: types.number,
  utilityId: types.maybeNull(types.string)
});
const StatementInfo = types.model('StatementInfo', {
  month: types.number,
  statementId: types.string,
  timestamp: types.string,
  year: types.number
});
const FinalStatementInfo = types.model('FinalStatementInfo', {
  avaliableFrom: types.string,
  fseId: types.maybeNull(types.string),
  fseReviewDaysPeriod: types.number,
  moveOutDate: types.string,
  overdueDays: types.number,
  residencyId: types.maybeNull(types.string),
  statement: types.maybeNull(StatementInfo),
  status: types.string,
  totalCharge: types.number
});
const MonthTotal = types.model('MonthTotal', {
  actualCharge: types.number,
  daysTotal: types.number,
  month: types.number,
  recommendedCharge: types.number,
  year: types.number
});
const Statement = types.model('Statement', {
  fileId: types.maybeNull(types.string),
  month: types.number,
  paperStatementId: types.maybeNull(types.string),
  year: types.number
});
const Totals = types.model('Totals', {
  actualGoodwillDeduction: types.maybeNull(types.number),
  actualNetCharges: types.maybeNull(types.number),
  actualTotal: types.maybeNull(types.number),
  adminFeeActualAmount: types.maybeNull(types.number),
  adminFeeRecommended: types.maybeNull(types.number),
  currentBalance: types.maybeNull(types.number),
  goodWillDeductionPercent: types.maybeNull(types.number),
  monthTotals: types.maybeNull(types.array(MonthTotal)),
  recommendedGoodwillDeduction: types.maybeNull(types.number),
  recommendedNetCharges: types.maybeNull(types.number),
  statementTotalDays: types.maybeNull(types.number)
});
const FinalStatementStore = types.model('FinalStatementStore', {
  accountIdValue: types.optional(types.string, ''),
  getFinalStatementsAsync,
  getFSEInfosAsync,
  FSEBillModalDataValue: types.optional(FSEBillModalData, {
    accountId: '',
    residentName: '',
    residencyId: '',
    unitName: '',
    propertyId: ''
  }),
  FSEBillModalIsLoadingValue: types.optional(types.boolean, false),
  FSEBillModalIsOpenValue: types.optional(types.boolean, false),
  FSEBillModalToggleValue: types.optional(types.boolean, true),
  FSEBillGeneralModalIsOpenValue: types.optional(types.boolean, false),
  FSEBillIsSubmitedValue: types.optional(types.boolean, false),
  fsePostedData: types.optional(FSEPosted, {
    batchId: '',
    fileId: '',
    month: 0,
    paperStatementId: '',
    propertyId: '',
    residencyId: '',
    residentAccountId: '',
    residentId: '',
    year: 0
  }),
  finalStatementIdValue: types.optional(types.string, ''),
  finalStatementsIsEmptyValue: types.optional(types.boolean, false),
  finalStatementInfoValue: types.optional(types.array(FinalStatementInfo), []),
  finalStatementsValue: types.optional(types.array(FinalStatement), []),
  moveOutDateValue: types.optional(types.string, ''),
  propertyIdValue: types.optional(types.string, ''),
  statementValue: types.optional(Statement, {
    fileId: null,
    month: 0,
    paperStatementId: null,
    year: 0
  }),
  submitFinalStatementsAsync,
  totalsValue: types.optional(Totals, {
    adminFeeActualAmount: 0,
    actualGoodwillDeduction: 0,
    actualNetCharges: 0,
    actualTotal: 0,
    currentBalance: 0,
    goodWillDeductionPercent: 0,
    adminFeeRecommended: 0,
    recommendedGoodwillDeduction: 0,
    recommendedNetCharges: 0,
    statementTotalDays: 0
  }),
  updateFinalStatementsAsync
}).actions(store => {
  return {
    clearFinalStatementInfo() {
      try {
        store.finalStatementInfoValue = cast([]);
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    setFinalStatementsAfterLoad(data) {
      try {
        if (data.response === null) {
          store.finalStatementsIsEmptyValue = true;
          return;
        }
        store.accountIdValue = data.response.accountId;
        store.finalStatementIdValue = data.response.id;
        store.finalStatementsIsEmptyValue = false;
        store.finalStatementsValue = cast([...data.response.finalStatementItems.filter(item => item.utilityId !== null).map(item => _objectSpread(_objectSpread({}, item), {}, {
          chargeMemo: '',
          creditMemo: ''
        }))]);
        store.moveOutDateValue = data.response.moveOutDate;
        store.propertyIdValue = data.response.propertyId;
        store.totalsValue = cast({
          actualGoodwillDeduction: data.response.actualGoodwillDeduction,
          actualNetCharges: data.response.actualNetCharges,
          actualTotal: data.response.actualTotal,
          adminFeeActualAmount: data.response.adminFeeActualAmount,
          adminFeeRecommended: data.response.adminFeeRecommended,
          currentBalance: data.response.currentBalance,
          goodWillDeductionPercent: data.response.goodWillDeductionPercent,
          monthTotals: cast(data.response.monthTotals),
          recommendedGoodwillDeduction: data.response.recommendedGoodwillDeduction,
          recommendedNetCharges: data.response.recommendedNetCharges,
          statementTotalDays: data.response.statementTotalDays
        });
        if (data.response.statement) {
          store.statementValue = {
            fileId: data.response.statement.fileId,
            month: data.response.statement.month,
            paperStatementId: data.response.statement.paperStatementId,
            year: data.response.statement.year
          };
        }
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    setFinalStatementsAfterSubmit(data) {
      try {
        store.fsePostedData = {
          batchId: data.response.batchId,
          fileId: data.response.fileId,
          month: data.response.month,
          paperStatementId: data.response.paperStatementId,
          propertyId: data.response.propertyId,
          residencyId: data.response.residencyId,
          residentAccountId: data.response.residentAccountId,
          residentId: data.response.residentId,
          year: data.response.year
        };
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    setFSEInfosAfterLoad(data) {
      try {
        store.finalStatementInfoValue = cast(data.response.finalStatements);
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    setFSEBillModalData(data) {
      try {
        store.FSEBillModalDataValue = {
          accountId: data.accountId,
          residentName: data.residentName,
          residencyId: data.residencyId,
          unitName: data.unitName,
          propertyId: data === null || data === void 0 ? void 0 : data.propertyId
        };
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    setFSEBillModalIsOpen(flag) {
      try {
        store.FSEBillModalIsOpenValue = flag;
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    setFSEBillModalToggle(flag) {
      try {
        store.FSEBillModalToggleValue = flag;
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    setFSEBillGeneralModalIsOpen(flag) {
      try {
        store.FSEBillGeneralModalIsOpenValue = flag;
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    setFSEBillIsSubmited(flag) {
      try {
        store.FSEBillIsSubmitedValue = flag;
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    setFSEBillModalIsLoadingValue(flag) {
      try {
        store.FSEBillModalIsLoadingValue = flag;
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    updateActualGoodwillDeduction(goodwillDeduction) {
      try {
        store.totalsValue.goodWillDeductionPercent = +goodwillDeduction;
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    updateChargeAmount(id, chargeAmount) {
      try {
        const index = store.finalStatementsValue.findIndex(item => item.id === id);
        store.finalStatementsValue[index].chargeAmount = +chargeAmount;
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    }
  };
}).views(store => ({
  get accountId() {
    return store.accountIdValue;
  },
  get fsePosted() {
    return toJS(store.fsePostedData);
  },
  get finalStatementId() {
    return store.finalStatementIdValue;
  },
  get finalStatements() {
    return toJS(store.finalStatementsValue);
  },
  get finalStatementsIsEmpty() {
    return store.finalStatementsIsEmptyValue;
  },
  get finalStatementInfo() {
    return toJS(store.finalStatementInfoValue);
  },
  get FSEBillIsSubmited() {
    return store.FSEBillIsSubmitedValue;
  },
  get FSEBillModalData() {
    return toJS(store.FSEBillModalDataValue);
  },
  get FSEBillModalIsOpen() {
    return store.FSEBillModalIsOpenValue;
  },
  get FSEBillModalIsLoading() {
    return store.FSEBillModalIsLoadingValue;
  },
  get FSEBillModalToggle() {
    return store.FSEBillModalToggleValue;
  },
  get FSEBillGeneralModalIsOpen() {
    return store.FSEBillGeneralModalIsOpenValue;
  },
  get moveOutDate() {
    return moment(store.moveOutDateValue).format(moment.HTML5_FMT.DATE);
  },
  get propertyId() {
    return store.propertyIdValue;
  },
  get statement() {
    return toJS(store.statementValue);
  },
  get totals() {
    return toJS(store.totalsValue);
  }
}));
export const fse = types.optional(FinalStatementStore, {});